/**
 * Ktora pozycja menu bocznego jest aktywna na danej trasie.
 *
 * Czysta funkcja, bo regula jest mniej oczywista, niz wyglada: NavLink porownuje WYLACZNIE
 * adres wlasnego linku, a "Analizy" prowadzi na "/", podczas gdy pojedyncza analiza zyje
 * pod "/analizy/:id". Z `end` na "/" pozycja gasla na stronie analizy (zgloszenie z testu
 * 04.10.2026), a bez `end` swiecilaby na KAZDEJ trasie, bo "/" jest prefiksem wszystkich.
 */

export interface PozycjaDoDopasowania {
  /** Adres, na ktory prowadzi link. */
  do: string;
  /** Dodatkowe sciezki, ktore tez nalezą do tej pozycji (np. "/analizy" dla listy na "/"). */
  nalezaTez?: readonly string[];
}

/** Bez koncowych ukosnikow ("/koszty/" to ta sama trasa co "/koszty"); korzen zostaje "/". */
function bezKoncowegoUkosnika(sciezka: string): string {
  const przyciete = sciezka.replace(/\/+$/, "");
  return przyciete === "" ? "/" : przyciete;
}

/** Sciezka jest baza albo lezy pod nia - granica na pelnym segmencie ("/koszty" nie pasuje do "/kosztyx"). */
function lezyPod(baza: string, sciezka: string): boolean {
  if (baza === "/") return sciezka === "/";
  return sciezka === baza || sciezka.startsWith(`${baza}/`);
}

export function czyPozycjaAktywna(pozycja: PozycjaDoDopasowania, pathname: string): boolean {
  const sciezka = bezKoncowegoUkosnika(pathname);
  return [pozycja.do, ...(pozycja.nalezaTez ?? [])].some((baza) => lezyPod(bezKoncowegoUkosnika(baza), sciezka));
}
